const state = {
    requestSentList: [], //assigment ids have payment request sent
};

const getters = {
    requestSentList: state => {
        return state.requestSentList;
    },
    requestByAssignmentId: state => assignmentId => {
        const requestList = state.requestSentList
        if(requestList.length === 0) return {};

        return requestList.find(request => request.assignment_id === assignmentId);
    }
};

const mutations = {
    setRequestSentList(state, requestSentList) {
        state.requestSentList = requestSentList;
    },
};

const actions = {
    async getRequestSentList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const projectId = payload.projectId;
                const response = (await axios.get("/admin/project/" + projectId + "/api/get-payment-requests"));
                commit("setRequestSentList", response.data.data);

                resolve(response)
            } catch (error) {
                reject(error)
            }
        })
    },
    async sendRequest({ commit, dispatch }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const formData = payload.formData;
                const response = (await axios.post("/admin/project/" + payload.projectId + "/api/send-payment-request", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }))
                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });


    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
